// noinspection DuplicatedCode

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Button from "@material-tailwind/react/Button";
import Modal from "@material-tailwind/react/Modal";
import ModalBody from "@material-tailwind/react/ModalBody";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import { useMutation } from "@tanstack/react-query";
import { fetchPost, fetchPostSilance, fetchGet } from "../../../../fetchers";
import { toast } from "react-toastify";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { alertService } from "../../../../services/AlertService";

import Loading from "../../../../components/loading/Loading";
import TableCard from "../../../../components/tablecard/TableCard";

import { getMinKaryawan, karyawanSelector } from "../../karyawan/karyawanSlice";
import {
  //   getIzinTransaksi,
  insertPerbaikanTransaksi,
  perbaikanTransaksiSelector,
  updatePerbaikanTransaksi,
} from "./perbaikanTransaksiSlice";

import { Colors } from "../../../../assets/Colors";
import { isRequired, useForm } from "../../../../components/isRequired";
import { KaryawanSelectorBuilder } from "../../karyawan/KaryawanSelector";

const PerbaikanPage = ({}) => {
  let initialState = {
    Nik: "",
    JenisIzin: -1,
    KeperluanIzin: "",
    Pengganti: "",
    Tiket: false,
  };
  const mutation = useMutation((param) => fetchGet("getPerbaikan", param));

  const mutationInput = useMutation((param) =>
    fetchPostSilance("insertPerbaikan", param)
  );
  const mutationDeleteAbsen = useMutation((param) =>
    fetchPostSilance("deleteAbsen", param)
  );

  const validations = [
    ({ Nik }) => isRequired(Nik) || { Nik: "NIK wajib diisi" },
    ({ JenisIzin }) =>
      isRequired(JenisIzin) || { JenisIzin: "Jenis izin wajib diisi" },
    ({ KeperluanIzin }) =>
      isRequired(KeperluanIzin) || {
        KeperluanIzin: "Keperluan izin wajib diisi",
      },
  ];

  const {
    changed,
    values,
    isValid,
    errors,
    touched,
    changeHandler,
    editHandler,
    clearHandler,
    submitHandler,
    customHandler,
  } = useForm(initialState, validations);
  const [buttonTouched, setButtonTouched] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [Tanggal, setTanggal] = useState("");
  const [TanggalHapus, setTanggalHapus] = useState("");
  const [TanggalAkhir, setTanggalAkhir] = useState(new Date());

  const [JamMasuk, setTJamMasuk] = useState("");
  const [JamKeluar, setJamKeluar] = useState("");

  const [isValidTanggalMulai, setIsValidTanggalMulai] = useState(true);
  const [isValidTanggalAkhir, setIsValidTanggalAkhir] = useState(true);
  const [dateChanged, setDateChanged] = useState(false);
  const [firstLoading, setFirstLoading] = useState(false);
  const [start, setStart] = useState(0);
  const [count, setCount] = useState(10);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(0);
  const [search, setSearch] = useState("");
  const [searchFetch, setSearchFetch] = useState(false);
  const [updateFetch, setUpdateFetch] = useState(false);

  const [insertFetch, setInsertFetch] = useState(false);
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [ShowModalAddDelete, setShowModalAddDelete] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [currentData, setCurrentData] = useState({});

  const perbaikan = useSelector(perbaikanTransaksiSelector);
  const karyawan = useSelector(karyawanSelector);
  const [TipeKaryawan, setTipeKaryawan] = useState("");

  useEffect(() => {
    const formData = {
      start: start,
      count: count,
      search: "",
    };
    mutation.mutate(formData);
    // disini
    // mutation.mutate(formData, {
    //     onSuccess: async (data, context) => {
    //       let calc = data?.count - 1;
    //       if (calc === 0) {
    //         calc = 1;
    //       }

    //       if (calc % count === 0) {
    //         calc = calc + 1;
    //       }

    //       let tempMaxPage = data.data ? Math.ceil(calc / count) : 1;
    //       setMaxPage(tempMaxPage);
    //     },
    //   });
  }, []);

  const reapprove = () => {
    mutation.mutate({
      start: start,
      count: count,
      search: search,
    });
  };

  function deleteHandler(e) {
    console.log(e);
  }

  function handleModal(status) {
    setShowModalAdd(status.showModalAdd);
    setShowModalEdit(status.showModalEdit);

    setShowModalAddDelete(status.ShowModalAddDelete);

    dispatch(getMinKaryawan({ search: "" }));
  }

  function handleUpdateIzin(param) {
    setUpdateFetch(true);

    const params = {
      provinsiID: param.dropdownProvinsiValue,
      namaIzin: param.inputOneValue,
      izinID: currentData.IzinID,
      status: param.status,
    };
    // dispatch(updateIzinTransaksi(params));
  }

  function searchTipeKaryawanHandler(searchValue) {
    let params = {
      start: start,
      count: count,
      tipekaryawan: TipeKaryawan,
      search: "",
    };
    mutation.mutate(params);

    setTipeKaryawan(searchValue);
  }

  return (
    <>
      <div className="md:ml-64">
        <div
          style={{ background: Colors.primary }}
          className="pt-14 pb-16 px-3 md:px-8 h-auto"
        >
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
          </div>
        </div>

        <div className="px-3 md:px-8 h-auto -mt-32">
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 px-4">
              <TableCard
                usingMutation={true}
                mutation={mutation}
                hrd={true}
                primaryID="ID"
                transaksi={true}
                tableData={mutation.data}
                deleteButton={true}
                deleteHandler={deleteHandler}
                deleteButtonAbsen={true}
                // handleSearch={handleSearch}
                searchPlaceholder="Perbaikan Absen"
                // updatePage={handleUpdatePage}
                // updateCount={handleUpdateCount}
                // currentData={handleCurrentData}
                currentPage={page}
                maxPage={maxPage}
                tableTitle="Master Perbaikan Absen"
                colOneTitle="ID"
                colOneData="ID"
                colTwoTitle="Nama Karyawan"
                colTwoData="NamaKaryawan"
                colThreeTitle="Keterangan"
                colThreeData="Keterangan"
                colFourTitle="Tanggal"
                colFourData="Tanggal"
                colEightTitle="Jam Keluar"
                colEightData="JamKeluar"
                colNineTitle="Jam Masuk"
                colNineData="JamMasuk"
                searchTipeKaryawanHandler={searchTipeKaryawanHandler}
                searchTipeKaryawan={true}
                // fetching={izin.isGetFetching}
                reapprove={reapprove}
                modal={handleModal}
                //   editEnabled={true}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="regular"
        active={showModalAdd}
        toggler={() => {
          setShowModalAdd(true);
        }}
      >
        <ModalHeader
          className="mt-20"
          toggler={() => {
            setTanggal("");
            // setTanggalAkhir("");
            setShowModalAdd(false);
            setShowModalEdit(false);
            setButtonTouched(false);
            clearHandler();
          }}
        >
          {showModalEdit ? "Edit Data" : "Tambah Data"}
        </ModalHeader>
        <ModalBody>
          <form className="w-full max-w-lg" onSubmit={submitHandler}>
            <KaryawanSelectorBuilder
              value={values.Nik}
              onChange={customHandler}
            />
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full px-3 md:mb-0 mb-6">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Keterangan
                </label>
                <input
                  value={values.Keterangan}
                  onChange={changeHandler}
                  name="Keterangan"
                  className={
                    (touched.Keterangan || buttonTouched) && errors.Keterangan
                      ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                      : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  type="text"
                />
                {(touched.Keterangan || buttonTouched) && errors.Keterangan && (
                  <p className="text-red-500 text-xs italic">
                    {errors.Keterangan}
                  </p>
                )}
              </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full px-3 md:mb-0 mb-6">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Tanggal
                </label>
                <DatePicker
                  className={
                    "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  scrollableYearDropdown
                  utcOffset={0}
                  selected={Tanggal}
                  onChange={(time) => {
                    setTanggal(time);
                  }}
                  name="Tanggal"
                />
                {/* {!isValidTanggal && (
                <p className="text-red-500 text-xs italic">
                  Tanggal wajib diisi
                </p>
              )} */}
              </div>
            </div>
            <div className="flex flex-wrap -mx-3">
              <div className="w-full md:w-1/2 px-3 mb-6">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Jam Masuk
                </label>
                <DatePicker
                  showTimeSelectOnly
                  showTimeInput
                  dateFormat="HH:mm"
                  selected={JamMasuk != "" ? new Date(JamMasuk) : ""}
                  className={
                    "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  onChange={(time) => {
                    setTJamMasuk(time);
                  }}
                />
              </div>

              <div className="w-full md:w-1/2 px-3 mb-6">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Jam Keluar
                </label>
                <DatePicker
                  showTimeSelectOnly
                  showTimeInput
                  dateFormat="HH:mm"
                  selected={JamKeluar != "" ? new Date(JamKeluar) : ""}
                  className={
                    "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  onChange={(time) => {
                    setJamKeluar(time);
                  }}
                />
              </div>
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <Button
            color="red"
            buttonType="link"
            onClick={() => {
              setTJamMasuk("");
              setJamKeluar("");
            }}
            ripple="dark"
          >
            Clear
          </Button>
          <Button
            color="red"
            buttonType="link"
            onClick={() => {
              setTanggal("");
              // setTanggalAkhir("");
              setShowModalAdd(false);
              setShowModalEdit(false);
              clearHandler();
            }}
            ripple="dark"
          >
            Cancel
          </Button>

          <Button
            // color={
            //   (isValid || (showModalEdit && dateChanged && !isValid)) &&
            //   isValidTanggalMulai &&
            //   isValidTanggalAkhir
            //     ? "green"
            //     : "blueGray"
            // }
            onClick={() => {
              if (!isValid && changed) {
                setButtonTouched(true);
              }
              let tempIsValid = true;
              if (tempIsValid) {
                const tanggal = {
                  JamMasuk:
                    JamMasuk != "" ? JamMasuk.toLocaleTimeString("id-ID") : "",
                  JamKeluar:
                    JamKeluar != ""
                      ? JamKeluar.toLocaleTimeString("id-ID")
                      : "",
                  Tanggal: Tanggal.toLocaleDateString("id-ID"),
                  ID: currentData.ID,
                };
                setShowModalAdd(false);
                setShowModalEdit(false);
                if (showModalEdit) {
                  dispatch(
                    updatePerbaikanTransaksi(Object.assign(values, tanggal))
                  );
                } else {
                  mutationInput.mutate(Object.assign(values, tanggal), {
                    onSuccess: async (data, context) => {
                      toast.success(data.message, {
                        position: "bottom-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                      });
                      setShowModalAdd(false);
                      setShowModalEdit(false);
                      mutation.mutate({
                        start: start,
                        count: count,
                        search: search,
                      });
                    },
                    onError: async (data, context) => {
                      toast.error(data.message, {
                        position: "bottom-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                      });
                    },
                  });

                  // dispatch(
                  //   insertPerbaikanTransaksi(Object.assign(values, tanggal))
                  // );
                }
              }
            }}
            // ripple={
            //   isValid && isValidTanggalMulai && isValidTanggalAkhir
            //     ? "light"
            //     : ""
            // }
          >
            SUBMIT
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        size="regular"
        active={ShowModalAddDelete}
        toggler={() => {
          setShowModalAddDelete(true);
        }}
      >
        <ModalHeader
          className="mt-20"
          toggler={() => {
            setTanggalHapus("");
            // setTanggalAkhir("");
            setShowModalAddDelete(false);
            setShowModalEdit(false);
            setButtonTouched(false);
            clearHandler();
          }}
        >
          {showModalEdit ? "Edit Data" : "Delete Data Absen"}
        </ModalHeader>
        <ModalBody>
          <form className="w-full max-w-lg" onSubmit={submitHandler}>
            <KaryawanSelectorBuilder
              value={values.Nik}
              onChange={customHandler}
            />

            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full px-3 md:mb-0 mb-6">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Tanggal
                </label>
                <DatePicker
                  className={
                    "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  selected={TanggalHapus}
                  onChange={(time) => {
                    setTanggalHapus(time);
                  }}
                  name="Tanggal"
                />
                {/* {!isValidTanggal && (
                <p className="text-red-500 text-xs italic">
                  Tanggal wajib diisi
                </p>
              )} */}
              </div>
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <Button
            color="red"
            buttonType="link"
            onClick={() => {
              setTanggalHapus("");
              // setTanggalAkhir("");
              setShowModalAddDelete(false);
              setShowModalEdit(false);
              clearHandler();
            }}
            ripple="dark"
          >
            Cancel
          </Button>

          <Button
            // color={
            //   (isValid || (showModalEdit && dateChanged && !isValid)) &&
            //   isValidTanggalMulai &&
            //   isValidTanggalAkhir
            //     ? "green"
            //     : "blueGray"
            // }
            onClick={() => {
              if (!isValid && changed) {
                setButtonTouched(true);
              }
              let tempIsValid = true;
              if (tempIsValid) {
                const tanggal = {
                  Tanggal: TanggalHapus.toLocaleDateString("id-ID"),
                  ID: currentData.ID,
                };
                setShowModalAddDelete(false);
                mutationDeleteAbsen.mutate(Object.assign(values, tanggal), {
                  onSuccess: async (data, context) => {
                    toast.success(data.message, {
                      position: "bottom-right",
                      autoClose: 5000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: false,
                      draggable: true,
                      progress: undefined,
                      theme: "light",
                    });
                    setShowModalAddDelete(false);
                    setShowModalEdit(false);
                    mutation.mutate({
                      start: start,
                      count: count,
                      search: search,
                    });
                  },
                  onError: async (data, context) => {
                    toast.error(data.message, {
                      position: "bottom-right",
                      autoClose: 5000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: false,
                      draggable: true,
                      progress: undefined,
                      theme: "light",
                    });
                  },
                });
              }
            }}
            // ripple={
            //   isValid && isValidTanggalMulai && isValidTanggalAkhir
            //     ? "light"
            //     : ""
            // }
          >
            SUBMIT
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default PerbaikanPage;
